export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img1-836eb059310d316d0aab49a162d1a1c3.png";